

import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
// import { linkHorizontal } from 'd3';

import { IDropdownSettings } from "ng-multiselect-dropdown";
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

interface AssetNode {
  id: any;
  assetName: string;
  children?: AssetNode[];
}
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-asset-employee-edit',
  templateUrl: './asset-employee-edit.component.html',
  styleUrls: ['./asset-employee-edit.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class AssetEmployeeEditComponent implements OnInit {
  buttonColorName: any;
  updateData: any;
  userListDataForAsset: any;
  dropdownSettingsForBand: IDropdownSettings = {};
  dropdownSettingsForAsset: IDropdownSettings = {};
  dropdownSettingsForEmployee: IDropdownSettings = {};
  selectedEmployeeIdForReport: any;
  dropdownData: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  year: any;
  fiscalYear: any;
  todayDate: any;
  datedisplay: any
  isReadOnly = true;
  loggedInUserRole: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoles: any;
  loggedInUserName: any;
  forAuthority: any
  constructor(private datePipe: DatePipe, public dialogRef: MatDialogRef<AssetEmployeeEditComponent>, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any, private encryptionService: EncryptionService, private config: Config, private httpService: HttpService,) {
    this.todayDate = new Date().toISOString().split('T')[0];
    console.log(data);

    this.datedisplay = this.datePipe;
    this.year = data?.year;
    this.fiscalYear = data?.fiscal_year;
    this.updateData = data?.data;
    this.forAuthority = data.authority
    console.log("this.updateData", this.updateData);
    if (this.data?.data != null) {
      this.selectedBand = this.updateData?.band;
      this.selectedEmployee = this.updateData?.employeeName;
      // this.selectedAssets = this.updateData?.assetId;
      console.log(this.selectedBand);
    }

  }
  assetOptions = [
    "RECEIVED_ASSET",
    "REPAIR_ASSET",
    "RETURNING_ASSET_DUE_TO_EXIT",
    "RECEIVED_AFTER_REPAIR"
  ];

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getAllaseetListingData();
    this.assetAllocationData();


    // this.allAssets = this.userListDataForAsset.users.map((asset: { assetName: any; }) => asset.assetName);

    this.dropdownSettingsForBand = {
      singleSelection: false,
      idField: 'id',
      textField: 'band',

      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,

    };
    this.dropdownSettingsForAsset = {
      singleSelection: true,
      idField: 'assetId',
      textField: 'asset',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,

    };
    this.dropdownSettingsForEmployee = {
      singleSelection: false, // or true if only one selection is allowed
      idField: 'userId',      // Key for unique IDs
      textField: 'employeName', // Key for displayed text
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true, // Enable search functionality
    };



  }
  selectedAsset: any;



  selectedEmployee: any;
  selectedSubAsset: any;

  filteredEmployees: any[] = [];
  filteredAssets: any[] = [];
  selectedBand: any[] = [];
  // selectedAssets:any;
  //   // This function will be triggered when the asset (band) changes
  onAssetChange(event: any) {
    console.log(event);


  }

  //   // This function will be triggered when an employee is selected


  onBandChange(event: any) {
    console.log('Selected Bands:', this.selectedBand); // Log the selected values (array of bands)
    this.selectedBand = event.value;  // Store the selected bands in the array



  }


  onEmployeeChange() {
    console.log(this.selectedBand);

    this.userListDataForAsset.users = this.userListDataForAsset.users.filter((elm: any) => this.selectedBand.includes(elm.band))
    console.log(this.userListDataForAsset);



  }
  selectedAssets: any[] = [];

  allAssets: string[] = []; // Holds all asset names to handle "Select All"



  // Event Handlers
  onSelectSingleSelectFilterReport(event: any) {
    console.log('Item selected:', event);
    console.log('Current selection:', this.selectedAssets);
    console.log('Item selected selectedBand', event);
    console.log('Current selection selectedBand:', event);
    this.groupEmployees(); // Ensure groupEmployees uses selectedAssets properly
  }

  selectAllEmpForReport(event: any) {
    console.log('All items selected:', event);
    this.selectedAssets = [...event]; // Assign all selected items to selectedAssets
    this.groupEmployees();
  }

  onDeSelectAllEmpForReport(event: any) {
    console.log('All items deselected:', event);
    this.selectedAssets = []; // Clear selectedAssets
    this.groupEmployees();
  }




  // Triggered when the asset dropdown is clicked
  onAssetClick() {
    console.log('Assets dropdown clicked');
    // You can handle other logic when dropdown is clicked, if needed
  }

  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = formatYearRanges(data?.data?.yearRanges);

  //     const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

  //     const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
  //     this.setSelectedYear(yearValue);

  //   });
  // }
  // setSelectedYear(yearValue: string): void {
  //   const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
  //   if (selectedYearObj) {
  //     this.selectedYearForCompetency = selectedYearObj?.year;
  //         // this.selectedYearForGraphOneHRAdmin = selectedYearObj?.year;
  //         // this.selectedYearForGraphTwoHRAdmin = selectedYearObj?.year;
  //         // this.selectedYearForGraphFifthHRAdmin = selectedYearObj?.year;
  //         // this.selectedYearForGraphSix = selectedYearObj?.year;
  //         // this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year;
  //         // this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year;

  //     let test = selectedYearObj?.year.split('-');
  //     this.fromYear = test[0];
  //     this.toYear = test[1];
  //   }
  // }




  assetManagementHeader = [
    { label: 'Asset', isMandatory: true, sortingName: 'asset' },
    { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
    { label: 'Band', isMandatory: true, sortingName: 'band' },
    { label: 'Allocating Dept', isMandatory: true, sortingName: 'allocatingAuthorityDept' },
    { label: 'Authority Name', isMandatory: true, sortingName: 'allocatingAuthorityName' },
    { label: 'Allocation Date', isMandatory: true, sortingName: 'reimbursementType' },
    { label: 'Current Asset Description', isMandatory: true, sortingName: 'startDate' },
    { label: 'Employee Status', isMandatory: true, sortingName: 'startDate' },
    { label: 'Employee Comment', isMandatory: true, sortingName: 'reimbursementType' },
    { label: 'Employee Comment Date', isMandatory: true, sortingName: 'startDate' },

    { label: 'HR ADMIN/Allocating Authority Comment', isMandatory: true, sortingName: 'reimbursementLimit' },
    { label: 'Authority Comment Date', isMandatory: true, sortingName: 'actualAmount' },


  ];




  AllAssetListingData: any[] = [];
  getAllaseetListingData() {
    this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.fiscalYear}/${this.year}`)
      .subscribe((elm: any) => {
        this.AllAssetListingData = elm.data;
        console.log(elm);


      })

  }


  originalAssets: any[] = [];
  assetAllocationData() {
    this.httpService.callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.fiscalYear}/${this.year}`)
      .subscribe((elm: any) => {
        console.log(elm);

        this.originalAssets = elm.data;


        this.groupEmployees();
      })

  }
  assets: any = [];
  allUsers: any[] = [];


  dropDownForband: any[] = [];
  dropDownForEmployee: any[] = [];
  finalTableListData: any[] = [];
   formatedataVariable = formatText;
  groupEmployees() {
    // Initialize an empty array to hold all users
    this.allUsers = [];

    // Loop through the original assets and collect all user details
    for (const asset of this.originalAssets) {
      this.allUsers.push({
        id: asset.id,
        employeeName: asset.employeeName,
        employeeComment: asset.employeeComment,
        employeeCommentDate: asset.employeeCommentDate,
        employeeAssetStatus: asset.employeeAssetStatus,
        allocatingAuthorityName: asset.authorityName,
        allocatingAuthorityDept: asset.authorityDepartment,
        employeeEmail: asset.employeeEmail,
        authorityEmail: asset.authorityEmail,
        assetName: asset.assetName,
        band: asset.band,
        userId: asset.userId,
        assetId: asset.assetId,
        dateOfAllocation: asset.dateOfAllocation,
        currentAssetDescription: asset.currentAssetDescription,
        authorityCommentDate: asset.authorityCommentDate,
        authorityDepartmentComment: asset.authorityDepartmentComment
      });
    }


    const specificAsset = this.assets.map((asset: any) => {
      return {
        assetName: asset.assetName,
        band: asset.band,

      };
    });

    const list = {
      assetData: specificAsset,
      users: this.allUsers
    }

    if (this.updateData != null) {
      this.userListDataForAsset = list;
      // console.log(this.userListDataForAsset);

      // this.dropDownForband = this.userListDataForAsset?.users?.map((user: any, index: number) => ({
      //   id: index, // Use a unique identifier (index or user-specific field)
      //   band: user.band, // Use assetName for the display text
      // }));
      // this.dropDownForEmployee = this.userListDataForAsset?.users?.map((user: any) => ({
      //   userId: user.userId, // Use a unique identifier (index or user-specific field)
      //   employeName: user.employeeName, // Use assetName for the display text
      //   band: user.band
      // }));
      // this.dropdownData = this.userListDataForAsset?.users?.map((user: any, index: number) => ({
      //   assetId: user.assetId, // Use a unique identifier (index or user-specific field)
      //   asset: user.assetName, // Use assetName for the display text
      //   employeeName: user.employeeName,
      //   userId: user.userId
      // }));
      // console.log("this.dropDownForband", this.dropDownForband);
      console.log(list,this.updateData);
      if (this.forAuthority === 'From Authority') {

        this.userListDataForAsset = list.users
          .filter((elm: any) => elm.userId === this.updateData.userId)
          .map((elm: any) => ({
            ...elm, // Keep all existing properties of the user object
            dateOfAllocation: elm.dateOfAllocation ? elm.dateOfAllocation : this.datedisplay,
            employeeCommentDate: elm.employeeCommentDate ? elm.employeeCommentDate : this.datedisplay,
            employeeAssetStatus: elm.employeeAssetStatus ? elm.employeeAssetStatus : "RECEIVED_ASSET"
          }));
      } else if (this.forAuthority === 'From Employee' || 'HR Admin') {

        this.userListDataForAsset = list.users
          .filter((elm: any) => elm.userId === this.updateData.userId)
          .map((elm: any) => ({
            ...elm, // Keep all existing properties of the user object
            dateOfAllocation: elm.dateOfAllocation ? elm.dateOfAllocation : this.datedisplay,
            employeeCommentDate: elm.employeeCommentDate ? elm.employeeCommentDate : this.datedisplay,
            employeeAssetStatus: elm.employeeAssetStatus ? elm.employeeAssetStatus : "RECEIVED_ASSET"
          }));
      }

      const selectedassetData = this.userListDataForAsset.map((elm: any) => elm.assetId);

      this.selectedAsset = selectedassetData;





    } else {
      this.userListDataForAsset = list

      this.dropDownForband = this.userListDataForAsset?.users?.map((user: any, index: number) => ({
        id: index, // Use a unique identifier (index or user-specific field)
        band: user.band, // Use assetName for the display text
      }));
      this.dropDownForEmployee = this.userListDataForAsset?.users?.map((user: any) => ({
        userId: user.userId, // Use a unique identifier (index or user-specific field)
        employeName: user.employeeName, // Use assetName for the display text
        band: user.band
      }));

      // const selectedBands = this.selectedBand?.map((elm: any) => elm.band)
      // // Filter the dropDownForEmployee array based on the selectedBand
      // this.dropDownForEmployee = this.dropDownForEmployee?.filter((elm: any) =>
      //   selectedBands?.includes(elm.band)
      // );


      this.dropdownData = this.userListDataForAsset?.users?.map((user: any, index: number) => ({
        assetId: user.assetId, // Use a unique identifier (index or user-specific field)
        asset: user.assetName, // Use assetName for the display text
        employeeName: user.employeeName,
        userId: user.userId
      }));


      // const selectedEmployes = this.selectedEmployee?.map((elm: any) => elm?.userId);
      // // Filter the dropDownForEmployee array based on the selectedBand
      // this.dropdownData = this.dropdownData?.filter((elm: any) =>
      //   selectedEmployes?.includes(elm.userId)
      // );
      console.log(this.selectedAsset);
      console.log(this.userListDataForAsset.users);

      // const selectedAsset = this.selectedAssets?.map((elm: any) => elm?.assetId);
      // console.log(selectedAsset);

      // this.finalTableListData = this.userListDataForAsset?.users?.filter((elm: any) => selectedAsset?.includes(elm.assetId));

      // this.userListDataForAsset.users = this.finalTableListData;
    }


  }


  updatedAssetData: Asset[] = [];


  updateAssetData(index: number) {
    // Ensure the index is valid and the users array exists
    console.log(index);
    console.log(this.userListDataForAsset);


    const updatedUser = this.userListDataForAsset[index];

    //-----------------------------------------employeeCommentDate---------------------------------------
    let selecteddateemployeeCommentDate = new Date(updatedUser.employeeCommentDate);  // Set the date at midnight
    let date = new Date(selecteddateemployeeCommentDate.getTime() - selecteddateemployeeCommentDate.getTimezoneOffset() * 60000);
    const employeeCommentDate = date.toISOString();

    const existingIndex = this.updatedAssetData.findIndex(
      data => data.id === updatedUser.id
    );

    if (existingIndex === -1) {
      // If not found, add a new object with updated data
      this.updatedAssetData.push({
        id: updatedUser.id,
        employeeComment: updatedUser.employeeComment,
        employeeCommentDate: employeeCommentDate,
        employeeAssetStatus: updatedUser.employeeAssetStatus
      });
    } else {
      // If found, update the existing object
      this.updatedAssetData[existingIndex] = {
        id: updatedUser.id,
        employeeComment: updatedUser.employeeComment,
        employeeCommentDate: employeeCommentDate,
        employeeAssetStatus: updatedUser.employeeAssetStatus, // Corrected property name
      };
    }
  }

  updateDataByEmployee() {

    this.updatedAssetData.forEach((element: any) => {
      this.httpService.callPutService(`${this.config.updateByEmployee}`, element).subscribe((result: any) => {
        // console.log(result);
        // this.assetAllocationData();
        if (result) {
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: result.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe((result) => {

            this.dialogRef.close();
          });
        }

      })
    })
  }

  cancelData() {
    this.dialogRef.close();
  }
}
interface Asset {

  id: any,
  employeeComment: any,
  employeeCommentDate: any,
  employeeAssetStatus: any

}
